// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fiche-contact {
  padding: 2rem;
  max-width: 120rem;
  margin: 0 auto;
}

/* .fiche-contact h1 {
  margin-bottom: 2rem;
} */

.details-client-fiche, .historique-commandes, .notes-section, .ajouter-commentaire {
  background-color: #FFFDFC;
  padding: 2rem;
  margin-bottom: 2rem;
  border-radius: 0.8rem;
}

.details-client,
.details-prestataires {
  background: #FFFDFC;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
}

.details-prestataires {
  width: 100%;
}

.details-client h2,
.details-prestataires h2 {
  font-size: 2.4rem;
  color: #2C3948;
  margin-bottom: 1.5rem;
}

.client-info strong,
.prestataire-content strong {
  margin-bottom: 0.8rem;
  font-size: 1.6rem;
  font-weight: 500;
}

.client-info {
  display: flex;
  gap: 2rem;
  flex-direction: column;
}

.info-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.info-container p {
  font-size: 1.6rem;
  color: #374151;
}

.commandes-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.fiche-contact .commande-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #E5E7EB;
}

.fiche-contact.commande-nom {
  font-size: 1.6rem;
  color: #374151;
}

.fiche-contact .commande-montant {
  font-size: 1.6rem;
  font-weight: 500;
  color: #374151;
}

.voir-commande {
  background-color: #2C3948;
  color: white;
  padding: 0.8rem 1.6rem;
  border-radius: 0.4rem;
  border: none;
  cursor: pointer;
  font-size: 1.4rem;
}

.total-commandes {
  margin-top: 2rem;
  text-align: right;
  font-size: 2rem;
  font-weight: 700;
}

.notes-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.note-item {
  background-color: #F3F4F6;
  padding: 1.5rem;
  border-radius: 0.4rem;
}

.note-text {
  font-size: 1.4rem;
  color: #374151;
  margin-bottom: 0.8rem;
}

.note-meta {
  font-size: 1.2rem;
  color: #6B7280;
  font-style: italic;
}

.ajouter-commentaire textarea {
  width: 100%;
  min-height: 10rem;
  padding: 1rem;
  border: 1px solid #E5E7EB;
  border-radius: 0.4rem;
  margin-bottom: 1rem;
  font-size: 1.4rem;
  resize: vertical;
}

.ajouter-button {
  background-color: #2C3948;
  color: white;
  padding: 0.8rem 1.6rem;
  border-radius: 0.4rem;
  border: none;
  cursor: pointer;
  font-size: 1.4rem;
  float: right;
}

.prestataire-content {
  padding: 1.5rem;
  background: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/pages/FicheContact/FicheContact.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".fiche-contact {\r\n  padding: 2rem;\r\n  max-width: 120rem;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* .fiche-contact h1 {\r\n  margin-bottom: 2rem;\r\n} */\r\n\r\n.details-client-fiche, .historique-commandes, .notes-section, .ajouter-commentaire {\r\n  background-color: #FFFDFC;\r\n  padding: 2rem;\r\n  margin-bottom: 2rem;\r\n  border-radius: 0.8rem;\r\n}\r\n\r\n.details-client,\r\n.details-prestataires {\r\n  background: #FFFDFC;\r\n  border-radius: 8px;\r\n  padding: 2rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  position: relative;\r\n}\r\n\r\n.details-prestataires {\r\n  width: 100%;\r\n}\r\n\r\n.details-client h2,\r\n.details-prestataires h2 {\r\n  font-size: 2.4rem;\r\n  color: #2C3948;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.client-info strong,\r\n.prestataire-content strong {\r\n  margin-bottom: 0.8rem;\r\n  font-size: 1.6rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.client-info {\r\n  display: flex;\r\n  gap: 2rem;\r\n  flex-direction: column;\r\n}\r\n\r\n.info-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.info-container p {\r\n  font-size: 1.6rem;\r\n  color: #374151;\r\n}\r\n\r\n.commandes-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.fiche-contact .commande-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1.5rem;\r\n  border-bottom: 1px solid #E5E7EB;\r\n}\r\n\r\n.fiche-contact.commande-nom {\r\n  font-size: 1.6rem;\r\n  color: #374151;\r\n}\r\n\r\n.fiche-contact .commande-montant {\r\n  font-size: 1.6rem;\r\n  font-weight: 500;\r\n  color: #374151;\r\n}\r\n\r\n.voir-commande {\r\n  background-color: #2C3948;\r\n  color: white;\r\n  padding: 0.8rem 1.6rem;\r\n  border-radius: 0.4rem;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.total-commandes {\r\n  margin-top: 2rem;\r\n  text-align: right;\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.notes-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.note-item {\r\n  background-color: #F3F4F6;\r\n  padding: 1.5rem;\r\n  border-radius: 0.4rem;\r\n}\r\n\r\n.note-text {\r\n  font-size: 1.4rem;\r\n  color: #374151;\r\n  margin-bottom: 0.8rem;\r\n}\r\n\r\n.note-meta {\r\n  font-size: 1.2rem;\r\n  color: #6B7280;\r\n  font-style: italic;\r\n}\r\n\r\n.ajouter-commentaire textarea {\r\n  width: 100%;\r\n  min-height: 10rem;\r\n  padding: 1rem;\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 0.4rem;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.4rem;\r\n  resize: vertical;\r\n}\r\n\r\n.ajouter-button {\r\n  background-color: #2C3948;\r\n  color: white;\r\n  padding: 0.8rem 1.6rem;\r\n  border-radius: 0.4rem;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 1.4rem;\r\n  float: right;\r\n}\r\n\r\n.prestataire-content {\r\n  padding: 1.5rem;\r\n  background: #FFFFFF;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
